import styled from "styled-components";
import userProfile from "../Assets/user.webp";
export const CustomAvatar = ({
  srcImage,
  altTxt = "Imagen de Perfil",
  avatarStyle = 28,
  loader
}) => {
  return (
    <Image
    
      src={srcImage || userProfile}
      alt={altTxt}
      style={{
        width: avatarStyle,
        height: avatarStyle,
        opacity:loader ? 0.5: 1
      }}
    />
  );
};

const Image = styled.img`
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
  border: 2px solid #E7E7E7;
`;
